// extracted by mini-css-extract-plugin
export default {"loader":"Checkout_loader__PpWIr","spin":"Checkout_spin__G5rzB"};